export default __webpack_public_path__ + "static/media/person-floor-green.8b5520bc.svg";